<script>
    import { onMount } from "svelte";
    import { emailValidator, requiredValidator } from './email_validations/validators.js'
    import { createFieldValidator } from './email_validations/validation.js'

    import { username, password, confirmPassword, email, confirmationСode, InitForm, key, isUniqueName, isUniqueEmail } from "../store.js";
    import { errorAlertMessage, errorUsernameMessage,  errorEmailMessage, errorPasswordMessage, errorBotMessage, sendRegistration, sendTgRegistration} from "../store.js";

    import { TabContent, TabPane, Button } from 'sveltestrap';
    import { Telegram, List, CheckLg, ExclamationLg} from "svelte-bootstrap-icons";

    let [ validity, validate ] = createFieldValidator(requiredValidator(), emailValidator())
    let cPassword = false;
    let emptyConfirmePassword = false;

    function onchangePassword(ev) {
      validations = [
        $password.length >= 8,
        $password.search(/[A-Z,А-Я]/) > -1,
        $password.search(/[0-9]/) > -1,
        $password.search(/[$&+,:;=?@#]/) > -1,
      ];
      strength = validations.reduce((acc, cur) => acc + cur, 0);
      // console.log(strength);
      if ($password.length>0){
        if (strength<4){$errorPasswordMessage = "Пароль не достаточно сложный";} 
        else {$errorPasswordMessage = "OK";} 
      } else {$errorPasswordMessage = "";} 
    }

    function onchangeConfirmePassword(ev) {
      cPassword = false;
      if ($errorPasswordMessage == "OK") {
          if ($password == $confirmPassword && $password.length> 0 && $confirmPassword.length > 0){
            cPassword = true;
          }
      } 
    }
    $: $username && isUniqueName();
    $: {if ($validity.message == undefined){isUniqueEmail();} else {$errorEmailMessage = $validity.message; }}
    $: {
       if (($password != "" && $confirmPassword == "") || ($password != "" && $confirmPassword != $password)) 
        emptyConfirmePassword = true; 
       else 
        emptyConfirmePassword = false;
       }
    
    onMount(async () => {
		   await InitForm();	
	  });
</script>

<style>
  .form-group label {
    font-weight: bold;
    float: left;
  }
  .form-group>p:first-child {
    font-weight: bold;
    float: left;
    padding: 3px;
  }
  .form-group input {
    border: 1px solid red;
  }
  :global(.nav-link) {
    color: red;
  } 
  :global(.nav-link:hover) {
    color: red;
  }
  .alert-danger {
    color: hsl(330, 100%, 50%); 
    font-weight: bold;
    text-shadow: 0 2px 0 0px hsl(330, 100%, 25%),
             0 3px 2px 0px hsla(330, 100%, 15%, 0.5);
  }
  .field-danger {
		border-color: red;
	}
	
	.field-success {
		border-color: green;
	}
</style>

<TabContent>
<TabPane tabId="Standart" active>
    <span slot="tab"><List/> Регистрация обычная </span>
        {#if $errorAlertMessage != "" }
          <div class="alert alert-danger col-12" role="alert">
            {$errorAlertMessage}
          </div>
        {/if}

        <div class="form-group">
          <label for="registration_username1">Имя пользователя</label>
          {#if $errorUsernameMessage == "OK"}
            <span style="color:green; float:left;"><CheckLg style="width: 30px; height:30px; margin-top: -6px;"/> OK</span> 
          {:else if $errorUsernameMessage != "" }
            <span style="color:red; float:left;"><ExclamationLg style="width: 30px; height:30px; margin-top: -6px;" /> {$errorUsernameMessage}</span> 
          {/if}
          <input type="text" id="registration_username1" class="form-control" placeholder="Имя пользователя" bind:value={$username} />
          <p>Обязательное поле. Не более 50 символов. Только буквы, цифры и символы @/./+/-/_.</p>
        </div> 
        
        <div class="standart-form">
          <div class="form-group">
              <label for="registration_email">Email</label>
              {#if $errorEmailMessage == "OK"}
                <span style="color:green; float:left;"><CheckLg style="width: 30px; height:30px; margin-top: -6px;"/> OK</span> 
              {:else if $errorEmailMessage != "" }
                <span style="color:red; float:left;"><ExclamationLg style="width: 30px; height:30px; margin-top: -6px;" />{$errorEmailMessage}</span> 
              {/if} 
              <input type="email" 
              id="registration_email" 
              class="form-control" 
              placeholder="email" bind:value={$email}
              class:field-danger={!$validity.valid}
			        class:field-success={$validity.valid}
              use:validate={$email} />
          </div>
          <div class="form-group"> 
              <label for="registration_password"> Пароль </label> 
              {#if $errorPasswordMessage == "OK"}
                <span style="color:green; float:left;"><CheckLg style="width: 30px; height:30px; margin-top: -6px;"/> OK</span> 
              {:else if $errorPasswordMessage != "" }
                <span style="color:red; float:left;"><ExclamationLg style="width: 30px; height:30px; margin-top: -6px;" /> {$errorPasswordMessage}</span> 
              {/if}
              <input type="password" id="registration_password" class="form-control" placeholder="пароль" bind:value={$password} on:input={onchangePassword}>
              <ul style="text-align: left; margin:3px;">
                  <li>Ваш пароль не должен совпадать с вашим именем или другой персональной информацией или быть
                      слишком похожим на неё
                  </li>
                  <li>Ваш пароль должен содержать как минимум 8 символов</li>
                  <li>Ваш пароль не может быть одним из широко распространённых паролей</li>
                  <li>Ваш пароль не может состоять только из цифр, но должен иметь хотя бы одну цифру</li>
                  <li>Ваш пароль должен содержать хотябы одну большую букву</li>
                  <li>Ваш пароль должен содержать хотябы один из спецсимволов ($&+,:;=?@#)</li>
              </ul>
          </div>
          <div class="form-group">
              <label for="registration_confirm_password">Пароль (повторно)</label>
              {#if cPassword }
                <span style="color:green; float:left;"><CheckLg style="width: 30px; height:30px; margin-top: -6px;"/> OK</span> 
              {:else if emptyConfirmePassword }
                 <span style="color:red; float:left;"><ExclamationLg style="width: 30px; height:30px; margin-top: -6px;" /> Повторите пароль</span>  
              {:else if $errorPasswordMessage != "" }
                {#if $errorPasswordMessage != "OK" }
                  <span style="color:red; float:left;"><ExclamationLg style="width: 30px; height:30px; margin-top: -6px;" /> {$errorPasswordMessage}</span> 
                {/if} 
              {/if} 
              <input type="password" id="registration_confirm_password" class="form-control" placeholder="пароль(повторно)" bind:value={$confirmPassword} on:input={onchangeConfirmePassword}>
              <p>Для подтверждения введите, пожалуйста, пароль ещё раз.</p>
          </div>
        </div>
        <div class="form-row">
          <div class="py-2">
            <Button outline color="danger" on:click={sendRegistration}>Регистрация</Button> 
          </div>
        </div> 
  </TabPane >

  <TabPane tabId="ByMessangers">
    <span slot="tab"><Telegram /> Регистрация через Telegram </span>
        {#if $errorAlertMessage != "" }
          <div class="alert alert-danger col-12" role="alert">
            {$errorAlertMessage}
          </div>
        {/if}

        <div class="form-group">
          <label for="registration_username">Имя пользователя</label> 
          {#if $errorUsernameMessage == "OK"}
            <span style="color:green; float:left;"><CheckLg style="width: 30px; height:30px; margin-top: -6px;"/> OK</span> 
          {:else if $errorUsernameMessage != "" }
            <span style="color:red; float:left;"><ExclamationLg style="width: 30px; height:30px; margin-top: -6px;" /> {$errorUsernameMessage}</span> 
          {/if}
          <input type="text" id="registration_username"  class="form-control" placeholder="Имя пользователя" bind:value={$username}>
        </div>

        <div class="bot-form">
          <div class="form-group" style="text-align: center; margin: 5px auto; width: 100%">
            <p>Имя бота в Telegram </p>
            <p style="color: red; font-weight: bold; border: 1px solid red; padding: 2px; border-radius: 3px; font-size: 16px;">@c78by_bot</p> 
          </div>   
        </div>

        <div class="bot-form">
          <div class="form-group">
              <label for="confirmation_code">Код регистрации (получить у бота)</label> 
              <input type="text" id="confirmation_code" class="form-control" placeholder="Код регистрации" 
              bind:value={$confirmationСode}>
          </div>   
        </div>
        <div class="form-row">
          <div class="py-2">
            <Button outline color="danger" on:click={sendTgRegistration}>Регистрация</Button>
          </div>
        </div> 
  </TabPane>
</TabContent> 


